import * as React from 'react';
import OrdinaryChart from './OrdinaryChart';
import RideJustStarted from '../RideJustStarted';
import { IGraphData, IGraphResponseData, getIsMoreThanOneDay } from '../GraphService';

interface IProps {
  responseData: IGraphResponseData[];
  isCompressed: boolean;
  name: string;
  isFilterableByRideId: boolean;
  vehicleId: number;
  loadData: () => void;
  isSelectable: boolean;
  selectedDate?: Date[];
}

function Stopped(props: IProps) {
  const [graphData, setGraphData] = React.useState<IGraphData>({
    xLabels: [],
    yLabels: [],
    tooltips: {},
    minLabels: [],
    maxLabels: [],
  });

  const getData = () => {
    const xLabels: string[] = [];
    const yLabels: (number | null)[] = [];
    const minLabels: string[] = [];
    const maxLabels: string[] = [];
    const tooltips = {};
    if (props.responseData) {
      props.responseData.forEach((i) => {
        if (!xLabels.includes(i.timestamp)) {
          xLabels.push(i.timestamp);
          yLabels.push(i.value);
          minLabels.push(i.min);
          maxLabels.push(i.max);
          tooltips[i.timestamp] = {
            address: i.address || `${i.latitude}, ${i.longitude}`,
            code: i.code,
          };
        }
      });
    }
    setGraphData({
      xLabels,
      yLabels,
      minLabels,
      maxLabels,
      tooltips,
    });
  };

  React.useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.responseData]);

  return (
    <div>
      {props.isFilterableByRideId && (
        <RideJustStarted vehicleId={props.vehicleId} loadData={props.loadData} />
      )}

      <OrdinaryChart
        name={props.name}
        graphData={graphData}
        noAnimation="animation"
        isCompressed={props.isCompressed}
        isSelectable={props.isSelectable}
        isFilterableByRideId={props.isFilterableByRideId}
        isMoreThanOneDay={
          !props.isFilterableByRideId && props.selectedDate
            ? getIsMoreThanOneDay(props.selectedDate)
            : false
        }
      />
    </div>
  );
}

export default React.memo(Stopped);
